"use client"
import { useState } from "react"
import { Bookmark, Lock } from "lucide-react"
import { useRouter } from "next/navigation"

interface Props {
  residencyId: string
  initialSaved: boolean
  isLoggedIn: boolean
  isSaver: boolean
}

export function SaveButton({ residencyId, initialSaved, isLoggedIn, isSaver }: Props) {
  const router = useRouter()
  const [saved, setSaved] = useState(initialSaved)
  const [loading, setLoading] = useState(false)

  async function toggle(e: React.MouseEvent) {
    e.preventDefault()
    e.stopPropagation()

    if (!isLoggedIn) {
      router.push("/login")
      return
    }
    if (!isSaver) {
      router.push("/pro")
      return
    }

    setLoading(true)
    try {
      const res = await fetch("/api/saved", {
        method: saved ? "DELETE" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ residencyId }),
      })
      if (res.ok) {
        setSaved(!saved)
        router.refresh()
      }
    } finally {
      setLoading(false)
    }
  }

  const title = !isLoggedIn
    ? "Sign in to save"
    : !isSaver
    ? "Saver plan required — upgrade for $4/mo"
    : saved
    ? "Remove from saved"
    : "Save residency"

  return (
    <button
      onClick={toggle}
      disabled={loading}
      title={title}
      aria-label={title}
      className={`relative p-1.5 rounded-lg transition-colors disabled:opacity-50 ${
        saved
          ? "text-[var(--primary)] bg-[var(--primary)]/10"
          : "text-[var(--muted-foreground)] hover:text-[var(--primary)] hover:bg-[var(--secondary)]"
      }`}
    >
      <Bookmark size={15} fill={saved ? "currentColor" : "none"} />
      {!isSaver && (
        <Lock size={8} className="absolute bottom-0.5 right-0.5 text-[var(--muted-foreground)]" />
      )}
    </button>
  )
}
